import React, { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { GuardForRoute } from './guard-for-route';
import { GuardForRouteService } from './guard-for-route-service';

export interface ProtectedRouteProps {
  guards?: GuardForRoute[];
}
export const ProtectedRoute: FC<ProtectedRouteProps> = (props) => {
  const { guards } = props;

  if (guards && GuardForRouteService.isProtectedRoute(guards)) {
    return <Navigate to={GuardForRouteService.getRedirectUrl(guards)} replace={true} />;
  }

  return <Outlet />;
};
